'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var course = function course() {
  return import('@/page/course');
};
var courseList = function courseList() {
  return import('@/page/course/course-list');
};
var courseDetail = function courseDetail() {
  return import('@/page/course/course-detail');
};
var courseTopics = function courseTopics() {
  return import('@/page/course/course-topics');
};
exports.default = [{
  path: '/course',
  name: 'course',
  component: course,
  children: [{
    path: 'course-list',
    name: 'course-list',
    component: courseList
  }, {
    path: 'course-detail',
    name: 'course-detail',
    component: courseDetail
  }, {
    path: 'course-topics',
    name: 'course-topics',
    component: courseTopics
  }]
}];